import React, { useState, useRef,forwardRef } from "react";
import ProjectBox from "./ProjectBox";
import ProjectTag from "./ProjectTag";
import { motion, useInView } from "framer-motion";
import food from "../../images/food.png";
import fun from "../../images/fun.png";
import portfolio from "../../images/portfolio.png";
import music from "../../images/music.png";
import star from "../../images/starbucks.png";
import job from "../../images/job.png";
import Crop from "../../images/Crop.png";
import Ecommerce from "../../images/E-commerce.png";
import todo from "../../images/todo.jpeg";
import weather from "../../images/weather.png"
import trend from "../../images/Trend.png"
import nas from "../../images/nas.png"
const projectsData = [
  {
    id: 10,
    title: "React Portfolio Website",
    description: "A personal portfolio website to showcase my projects and skills. Built using React and hosted on Firebase.",
    image: portfolio,
    tag: ["Web"],
    target: "_blank",
    previewUrl:"/"
  },
  {
    id: 2,
    title: "CropCareConnect - Agricultural Website",
    description: "Developed the Agricultural website, focusing on UI/UX design, user-friendly interfaces and accessibility.",
    image: Crop,
    tag: ["UI/UX", "Web"],
    target: "_blank",
    previewUrl: "https://www.figma.com/design/dyzHBYbjTJt40gXCuUdtXT/CropCareConnect?node-id=3-69&t=xltAW6Xqd5uWFKEh-0",
  },
  {
    id: 3,
    title: "Amazon clone",
    description: "Replicated the Amazon website, focusing on UI/UX design and implemented features of this website, focusing on user-friendly interfaces.",    image: Ecommerce,
    tag: ["Web","UI/UX"],
    target: "_blank",
    previewUrl: "https://www.figma.com/design/HHIBevMVglVkGnbuHPRoDN/Music?node-id=0-1&t=evi0OWeWl1aeOVOh-0",
  },
  {
    id: 4,
    title: "Food Delivery Application",
    description: "Developed a food delivery app and UI/UX design too, ensuring seamless user interaction and navigation.",
    image: food,
    target: "_blank",
    tag: ["UI/UX", "Android"],
    previewUrl: "https://www.figma.com/design/K9PrmGe46xREHbkIFJoRF4/Food-Delivery?node-id=0-1&t=oq3JsLefxyPzWGjw-0",
  },
  {
    id: 5,
    title: "Music App",
    description: "Created a UI/UX design for a music application, focusing on user-friendly interfaces and accessibility.",
    image: music,
    tag: ["UI/UX"],
    target: "_blank",
    previewUrl: "https://www.figma.com/design/HHIBevMVglVkGnbuHPRoDN/Music?node-id=0-1&t=evi0OWeWl1aeOVOh-0",
  },
  {
    id: 6,
    title: "Fun Game",
    target: "_blank",
    description: "Developed a web-based puzzle game using JavaScript, providing an interactive experience.",
    image: fun,
    tag: ["Web"],
    previewUrl: "https://puzzle-pop-seema81.web.app/",
  },
  {
    id: 7,
    title: "Job Query App",
    description: "An Android application to streamline job queries and enhance the job search process.",
    image: job,
    tag: ["Android"],
    previewUrl: "https://github.com/seemakumari84/JobQuery-App",
    target: "_blank",
  },
  {
    id: 8,
    title: "Starbucks",
    description: "Designed a UI/UX for a Starbucks application, focusing on usability and a modern look.",
    image: star,
    tag: ["UI/UX"],
    target: "_blank",
    previewUrl: "https://www.figma.com/design/JLpPDpPJPNkGN22UAjxkMN/Starbucks?node-id=0-1&t=Ve8ajyefsID1h2qe-0",
  },
  {
    id: 9,
    title: "Nas.io India Clone",
    description: "Replicated the Nas.io India website, focusing on UI/UX design and implemented features.",
    image: nas,
    tag: ["Web"],
    target: "_blank",
    previewUrl: "https://github.com/seemakumari84/Nas.io-website-clone",
  },
  {
    id: 12,
    title: "Trendinghub - E-commerce App",
    description: "Developed a app using the MERN stack. The application features a functional shopping cart.",
    image: trend,
    tag: ["Web"],
    target: "_blank",
    previewUrl: "https://github.com/seemakumari84/E-commerce",
  },
  
 {
    id: 11,
    title: "Todo App",
    description: "Created an Android application to help users manage and track their daily tasks and to-dos.",
    image: todo,
    tag: ["Android"],
    target: "_blank",
    previewUrl: "https://github.com/seemakumari84/Todo-app",
  },
  {
    id: 1,
    title: "Weather App",
    description: "Developed a weather forecasting web application that displays current weather conditions and forecasts.",
    image: weather,
    tag: ["Web"],
    target: "_blank",
    previewUrl: "https://github.com/seemakumari84/weather-app",
  },

];

const ProjectsSection = forwardRef((props,ref) => {
  const [tag, setTag] = useState("Web");
  const isInView = useInView(ref, { once: true });

  const handleTagChange = (newTag) => {
    setTag(newTag);
  };

  const filteredProjects = projectsData.filter((project) =>
    project.tag.includes(tag)
  );

  const cardVariants = {
    initial: { y: 50, opacity: 0 },
    animate: { y: 0, opacity: 1 },
  };

  return (
    <section id="projects" ref={ref}>
      <h2 className="text-center text-4xl font-bold text-white mt-10 mb-8 md:mb-12">
        My Projects
      </h2>
      <div className="text-white flex flex-row justify-center items-center gap-2 py-6 px-10">
        <ProjectTag
          onClick={handleTagChange}
          name="Web"
          isSelected={tag === "Web"}
        />
        <ProjectTag
          onClick={handleTagChange}
          name="UI/UX"
          isSelected={tag === "UI/UX"}
        />
        <ProjectTag
          onClick={handleTagChange}
          name="Android"
          isSelected={tag === "Android"}
        />
      </div>
      <ul className="grid grid-cols-1 m-5 sm:grid-cols-2 md:grid-cols-3 gap-8 md:gap-12">
        {filteredProjects.map((project, index) => (
          <motion.li
            key={index}
            variants={cardVariants}
            initial="initial"
            animate={isInView ? "animate" : "initial"}
            transition={{ duration: 0.3, delay: index * 0.4 }}
          >
            <ProjectBox
              key={project.id}
              title={project.title}
              description={project.description}
              imgUrl={project.image}
              gitUrl={project.gitUrl}
              previewUrl={project.previewUrl}
              target={project.target}
            />
          </motion.li>
        ))}
      </ul>
    </section>
  );
});

export default ProjectsSection;
